import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import TextLabel from "../../Components/TextLabel/TextLabel";
import Checkbox from "./Checkbox";
import { assignServicesList, getAssignServicesList, getServicesList, serviceList } from "../../utils/api";
import { isEmpty } from "../../utils/common";
import { AlertWrapper } from "../../Components/Modal/style";
import ConfirmBox from "../../Components/ConfirmBox/ConfirmBox";
import LocalLoader from "../../Components/Loader/LocalLoader";

function ManagedServices() {
  const [loader, setLoader] = useState(false);
  const [listing, setListing] = useState([]);
  const [assignService, setAssignService] = useState([]);
  const [editService, setEditService] = useState([]);
  const [message, setMessage] = useState({});
  const [openBox,setOpenBox] = useState(false);
  const [selectType,setSelectType] = useState("")



  const location = useLocation();
    const navigate = useNavigate();
  const item = location.state;



  useEffect(() => {
    if (isEmpty(item)) return;
    getListing();
  }, [item]);

  const getListing = (onlyAssign = false) => {
    setLoader(true);
  
    if (onlyAssign) {
      getAssignServicesList(item?.uuid)
        .then((assignService) => {
          setLoader(false);
          if (assignService?.data?.success) {
            setAssignService(assignService?.data?.data?.services || []);
            setEditService(assignService?.data?.data?.services || []);
          }
        })
        .catch((error) => {
          setLoader(false);
          console.error("Error fetching assign services:", error);
        });
    } else {
      // Call both APIs
      Promise.all([getServicesList(), getAssignServicesList(item?.uuid)])
        .then(([services, assignService]) => {
          setLoader(false);
          if (services?.data?.success) {
            setListing(services?.data?.data || []);
          }
          if (assignService?.data?.success) {
            setAssignService(assignService?.data?.data?.services || []);
            setEditService(assignService?.data?.data?.services || []);
          }
        })
        .catch((error) => {
          setLoader(false);
          console.error("Error fetching data:", error);
        });
    }
  };
  

  const change = (e) => {
    const value = e.target.value;
    setEditService((prev) => {
      if (prev.includes(value)) {
        return prev.filter((item) => item !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  const selectAll = (e) =>{
      console.log(e.target.checked);
      if(selectType !== "selectAll"){
        setSelectType("selectAll")
        const serviceSkus = (listing || []).map(item => item.serviceSku);
        setEditService([...serviceSkus]);
      }else{
        setSelectType("");
        setEditService([...assignService]);
      }
  }
  const unSelectAll = (e) =>{
      console.log(e.target.checked);
      if(selectType !== "unSelectAll"){
        setSelectType("unSelectAll")
        setEditService([]);
      }else{
        setSelectType("");
        setEditService([...assignService]);
      }
  }

  const updateList = () =>{
    const params = {
      userId:item?.uuid,
      services: editService,
    }
    setOpenBox(false)
    setLoader(true)
    assignServicesList(params).then((resp) =>{
   
      if(resp?.data?.success){
        getListing(true)
        setMessage({ msg: resp?.data?.msg, type: "success" });
      }else{
        setLoader(false)
        let msg = "";
        if (resp?.data?.errorCodeList.length > 0) {
          msg = resp?.data?.errorCodeList[0];
        } else {
          msg = resp?.data?.msg;
        }
        setMessage({ msg: msg, type: "error" });
      }

    }).catch(()=>{
      setLoader(false);
      setMessage({ msg: "Something went wrong.", type: "error" });
    })
  }

  useEffect(()=>{
    if(isEmpty(message)) return
  const timerId =   setTimeout(() => {
      setMessage({});
    }, 5000);

    return(()=>{
      clearTimeout(timerId);
    })
  },[message])

  

  return (
    <>
       {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="transaction_main_container" style={{ padding: "30px" }}>
        <div className="transaction_head">
          <div className="transaction_heading" style={{ alignItems: "center" }}>
            <div className="transaction_left flex gap-10 noPrint" style={{ alignItems: "center" }}>
            <div onClick={()=>navigate("/retailerList")}
            className="noPrint"
            style={{cursor:"pointer"}}
            ><i className="fa-solid fa-arrow-left"></i></div>
              <label>Managed Services</label>
           
            </div>
            
          </div>
        </div>
        <FilterWrapper>
          <div className=" flex filterBox">
            <div className="flex align-items justify-between gap-50">
              <TextLabel
                title="Retailer Name"
                value={`${item?.firstName || "-"} ${item?.lastName || ""}`}
              />
              <TextLabel title="Username" value={`${item?.userName || "-"}`} />
              <TextLabel
                title="Package Assigned "
                value={`${item?.userPkg || "-"}`}
              />
            </div>
          </div>
        </FilterWrapper>

        <div className="">
         <div className="flex justify-between">
         <h1 className="main_heading">Permission List</h1>
         <div className="flex gap-20">
         <Checkbox
                      label="Select All"
                      value=""
                      key={"-111"}
                      checked={selectType === "selectAll"}
                      onChange={selectAll}
                    />
         <Checkbox
                      label="Unselect All"
                      value=""
                      key={"-1"}
                      checked={selectType === "unSelectAll"}
                      onChange={unSelectAll}
                    />
         </div>
         </div>
          {loader && <LocalLoader className="tableLoader" />}
          <div className="checkbox_container flex">
            <div className="flex  row  permission_list_data">
              {listing &&
                listing.map((value, index) => {
                  return (
                    <Checkbox
                    className={assignService.includes(value.serviceSku)?"assign":""}
                      label={value.serviceName}
                      value={value.serviceSku}
                      key={index}
                      checked={editService.includes(value.serviceSku)}
                      onChange={change}
                    />
                  );
                })}
            </div>
          </div>
        </div>

        <div className="permission_btn">
          <button className="userlist_btn mt-20" onClick={() => setOpenBox(true)}>
            Update
          </button>
        </div>
      </div>
     {openBox && <ConfirmBox cancel={()=>setOpenBox(false)} ok={updateList}>
      <label>Do you want to update this user's service permissions?</label>
      </ConfirmBox>}
    </>
  );
}

export default ManagedServices;
